import { mainStore } from "../stores/MainStore";

export const useObservabilityStore = () => {
  return mainStore.observabilityStore;
};
